import React, { useEffect, useState } from 'react';
import { LeftInfo } from './LeftInfo';
import { RightInfo } from './RightInfo';
import { arrayToSimpleObj } from '@/pages/opinion/utils';
import { getHeroStatsInfo } from '@/pages/opinion/services/hero';
import ReviewsModal from '@/pages/opinion/components/ReviewsModal';
import { LanguageType } from '../../types/common';
import './index.scss';
import useReviewModalData from '../ReviewsModal/useReviewModalData';
import GptPanelItem from './GptPanelItem';

export default function TableExpandableDetail({
  language,
  params,
  noShowChannel = false,
  hasGptPanel = false,
  gptValue,
  sortItem
}: {
  noShowChannel?: boolean;
  language: LanguageType;
  params: any;
  hasGptPanel?: boolean;
  gptValue?: { title: string; value: string }[];
  sortItem?: 'comment_time' | 'engagement';
}) {
  const [leftInfoData, setLeftInfoData] = useState({
    language: [],
    country: [],
    channel: [],
  });
  const [sentimentCountMap, setSentimentCountMap] = useState({});
  const [loading, setLoading] = useState(false);
  const [apiError, setApiError] = useState(false);
  useEffect(() => {
    setLoading(true);
    setApiError(false);
    getHeroStatsInfo({
      ...params,
      metrics: ['language', 'channel', 'country', 'sentiment'],
    })
      .then((data: any) => {
        let { sentiment_list, country_list, language_list, channel_list } =
          data || {
            sentiment_list: [],
            country_list: [],
            language_list: [],
            channel_list: [],
          };
        setLeftInfoData({
          country: country_list,
          language: language_list,
          channel: channel_list,
        });
        setSentimentCountMap(
          arrayToSimpleObj(sentiment_list, 'mentions', 'kind') || {},
        );
      })
      .finally(() => {
        setLoading(false);
      });
  }, []);

  const { reviewsVisible, data, openModal, toggleModal } = useReviewModalData();

  return (
    <div className="table-expandable-detail">
      <LeftInfo
        loading={loading}
        noShowChannel={noShowChannel}
        apiError={apiError}
        leftInfoData={leftInfoData}
      ></LeftInfo>
      <RightInfo
        commonParams={params}
        sentimentCountMap={sentimentCountMap}
        language={language}
        hasGptPanel={hasGptPanel}
        itemClick={(item: any): void => {
          openModal(item);
        }}
        sortItem={sortItem}
      >
        <GptPanelItem filter={params}></GptPanelItem>
      </RightInfo>
      <ReviewsModal
        visible={reviewsVisible}
        data={data}
        language={language}
        close={toggleModal}
      />
    </div>
  );
}
